<template>
  <v-row>
    <v-col cols="12">
      <div v-if="emptyOpenings" class="emptyOpenings" >
        <v-icon color="orange">error_outline</v-icon>
        <span class="orange--text">{{$t('locations.empty_openings')}}</span>
      </div>
    </v-col>
    <v-col cols="12">
      <div v-for="(day, index) in days" :key="index">
        <div v-if="day === 'exceptions'">
        </div>
        <div v-else>
          <v-row class="opening-day">
            <v-col cols="2">
              <span>{{day}}:</span>
            </v-col>
            <v-col cols="7">
              <div v-for="(hours, index) in openingHours" :key="day+index">
                <LocationFormOpeningsRange
                  v-if="hours.day == day"
                  :day="day"
                  v-model="openingHours[index]"
                  :index="index"
                  @remove-range="removeRange"
                />
              </div>
            </v-col>
            <v-col offset-md="1" cols="2">
              <v-btn text small @click="addNewOpeningsToDay(day)">+ Add</v-btn>
            </v-col>
          </v-row>
        </div>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import LocationFormOpeningsRange from '@/components/locations/LocationFormOpeningsRange'
export default {
  name: 'LocationFormOpenings',
  components: {
    LocationFormOpeningsRange
  },
  props: ['value'],
  data () {
    return {
      days: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday', 'exceptions'],
      openingHours: JSON.parse(JSON.stringify(this.value))
    }
  },
  watch: {
    openingHours: {
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    }
  },
  computed: {
    emptyOpenings () {
      return this.openingHours.length === 0
    }
  },
  methods: {
    addNewOpeningsToDay (day) {
      let index = Math.max(...Object.keys(this.openingHours)) + 1
      // this.openingHours.push({ day: day, from: '06:00', to: '18:00' })
      // this.openingHours[index] = { day: day, from: '06:00', to: '18:00' }
      this.$set(this.openingHours, index, { day: day, from: '06:00', to: '18:00' })
      // console.log('1', this.openingHours)
      // if (this.openingHours[day] == null) {
      //   // this.$set(this.openingHours, day, [])
      //   this.openingHours.push({ [day]: [] })
      //   // this.openingHours.day = []
      //   console.log('2', this.openingHours)
      //   this.openingHours[day].push({ from: null, to: null })
      //   console.log('3', this.openingHours)
      //   // this.openingHours.day = { from: null, to: null }
      // } else {
      //   this.openingHours[day].push({ from: null, to: null })
      // }
      // console.log('4', this.openingHours)
    },
    removeRange: function (day, index) {
      this.$delete(this.openingHours, index)
    }
  }
}
</script>

<style lang="scss" scoped>
  .opening-day {
    border-bottom: 1px solid lightgray;
    margin-bottom: 16px !important;
    min-height: 61px;

    span{
      font-size: 16px;
      font-weight: 500;
    }

    .v-btn {
      margin: 0;
    }
  }
  .emptyOpenings {
    span {
      font-size: 16px;
      padding-left: 5px;
    }
  }
</style>
